(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("async-saga", [], factory);
	else if(typeof exports === 'object')
		exports["async-saga"] = factory();
	else
		root["async-saga"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectSpread");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("redux-saga/effects");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/regenerator");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/asyncToGenerator");

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "@babel/runtime/helpers/objectSpread"
var objectSpread_ = __webpack_require__(0);
var objectSpread_default = /*#__PURE__*/__webpack_require__.n(objectSpread_);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(6);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(2);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(3);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "@babel/runtime/regenerator"
var regenerator_ = __webpack_require__(7);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(4);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/asyncToGenerator"
var asyncToGenerator_ = __webpack_require__(9);
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);

// CONCATENATED MODULE: ./src/reducer/index.js




var _createReducer;



var PREFIX = '@@api-saga/';
var API = "".concat(PREFIX, "API");
var API_INIT = "".concat(PREFIX, "API_INIT");
var API_START = "".concat(PREFIX, "API_START");
var API_PROGRESS = "".concat(PREFIX, "API_PROGRESS");
var API_SUCCESS = "".concat(PREFIX, "API_SUCCESS");
var API_DESTROY = "".concat(PREFIX, "API_DESTROY");
var API_ERROR = "".concat(PREFIX, "API_ERROR");
var API_COMPLETE = "".concat(PREFIX, "API_COMPLETE");
var API_CLEANUP = "".concat(PREFIX, "API_CLEANUP");
var reducer_initialState = {};
var apiReducer = createReducer(reducer_initialState, (_createReducer = {}, defineProperty_default()(_createReducer, API_INIT, function (state, _ref) {
  var params = _ref.params,
      action = objectWithoutProperties_default()(_ref, ["params"]);

  return objectSpread_default()({}, state, defineProperty_default()({}, getKey(action), objectSpread_default()({}, state[getKey(action)], {
    data: action.cache ? Object(external_lodash_["get"])(state, "".concat(getKey(action), ".data")) : undefined,
    uuid: action.uuid,
    response: undefined,
    loading: false,
    progress: 0,
    loaded: false,
    params: params
  })));
}), defineProperty_default()(_createReducer, API_START, function (state, _ref2) {
  var params = _ref2.params,
      action = objectWithoutProperties_default()(_ref2, ["params"]);

  return objectSpread_default()({}, state, defineProperty_default()({}, getKey(action), objectSpread_default()({}, state[getKey(action)], {
    data: action.cache ? Object(external_lodash_["get"])(state, "".concat(getKey(action), ".data")) : undefined,
    loading: true,
    response: undefined,
    progress: 0,
    params: params
  })));
}), defineProperty_default()(_createReducer, API_SUCCESS, function (state, _ref3) {
  var response = _ref3.response,
      data = _ref3.data,
      status = _ref3.status,
      params = _ref3.params,
      action = objectWithoutProperties_default()(_ref3, ["response", "data", "status", "params"]);

  return objectSpread_default()({}, state, defineProperty_default()({}, getKey(action), objectSpread_default()({}, state[getKey(action)], {
    params: params,
    status: status,
    data: data,
    response: response,
    errors: null
  })));
}), defineProperty_default()(_createReducer, API_ERROR, function (state, _ref4) {
  var errors = _ref4.errors,
      response = _ref4.response,
      status = _ref4.status,
      params = _ref4.params,
      action = objectWithoutProperties_default()(_ref4, ["errors", "response", "status", "params"]);

  return objectSpread_default()({}, state, defineProperty_default()({}, getKey(action), objectSpread_default()({}, state[getKey(action)], {
    errors: errors,
    status: status,
    response: response,
    params: params
  })));
}), defineProperty_default()(_createReducer, API_DESTROY, function (state, _ref5) {
  var params = _ref5.params,
      response = _ref5.response,
      action = objectWithoutProperties_default()(_ref5, ["params", "response"]);

  return objectSpread_default()({}, state, defineProperty_default()({}, getKey(action), objectSpread_default()({}, state[getKey(action)], {
    status: action.status,
    data: null,
    params: params,
    response: response
  })));
}), defineProperty_default()(_createReducer, API_PROGRESS, function (state, _ref6) {
  var progress = _ref6.progress,
      params = _ref6.params,
      action = objectWithoutProperties_default()(_ref6, ["progress", "params"]);

  return objectSpread_default()({}, state, defineProperty_default()({}, getKey(action), objectSpread_default()({}, state[getKey(action)], {
    progress: progress,
    params: params
  })));
}), defineProperty_default()(_createReducer, API_COMPLETE, function (state, _ref7) {
  var params = _ref7.params,
      action = objectWithoutProperties_default()(_ref7, ["params"]);

  return objectSpread_default()({}, state, defineProperty_default()({}, getKey(action), objectSpread_default()({}, state[getKey(action)], {
    loading: false,
    progress: 0,
    loaded: true,
    params: params
  })));
}), defineProperty_default()(_createReducer, API_CLEANUP, function (state, action) {
  return Object(external_lodash_["omit"])(state, getKey(action));
}), _createReducer));
/* harmony default export */ var src_reducer = (apiReducer);
// CONCATENATED MODULE: ./src/utils/index.js





 // wrap request sagas in a promise so redux-form can deal with them

function asyncSaga(_x) {
  return _asyncSaga.apply(this, arguments);
}

function _asyncSaga() {
  _asyncSaga = asyncToGenerator_default()(
  /*#__PURE__*/
  regenerator_default.a.mark(function _callee(_ref) {
    var dispatch, kwargs;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref.dispatch, kwargs = objectWithoutProperties_default()(_ref, ["dispatch"]);
            _context.prev = 1;
            _context.next = 4;
            return new Promise(function (resolve, reject) {
              dispatch(objectSpread_default()({
                dispatch: dispatch,
                resolve: resolve,
                reject: reject
              }, kwargs));
            });

          case 4:
            return _context.abrupt("return", _context.sent);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);

            if (!kwargs.body) {
              _context.next = 11;
              break;
            }

            throw new Error(_context.t0.errors);

          case 11:
            return _context.abrupt("return", objectSpread_default()({}, _context.t0));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 7]]);
  }));
  return _asyncSaga.apply(this, arguments);
}

function createReducer(initialState, handlers) {
  return function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    if (Object(external_lodash_["has"])(handlers, action.type)) {
      return handlers[action.type](state, action);
    }

    return state;
  };
}
function getKey() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$endpoint = _ref2.endpoint,
      endpoint = _ref2$endpoint === void 0 ? '' : _ref2$endpoint,
      _ref2$method = _ref2.method,
      method = _ref2$method === void 0 ? '' : _ref2$method,
      _ref2$ns = _ref2.ns,
      ns = _ref2$ns === void 0 ? '' : _ref2$ns;

  if (!endpoint) {
    throw new Error('getKey: must provide `endpoint`');
  }

  var key = '';

  if (method) {
    key += "".concat(method, "-");
  }

  key += endpoint;

  if (ns) {
    key = "".concat(ns, "-").concat(key);
  }

  return key;
}
function clientDispatchWrapper(dispatch, payload) {
  return function (kwargs) {
    return asyncSaga(objectSpread_default()({}, payload, kwargs, {
      dispatch: dispatch,
      type: API
    }));
  };
}
// CONCATENATED MODULE: ./src/components/ApiProvider/index.js






var ApiContext = Object(external_react_["createContext"])({
  store: {},
  clients: {},
  getRequest: function getRequest() {}
});

function ApiProvider_getRequest(store, reducerKey, defaultUserType, _ref) {
  var ns = _ref.ns,
      endpoint = _ref.endpoint,
      method = _ref.method,
      params = _ref.params,
      userType = _ref.userType,
      _ref$cache = _ref.cache,
      cache = _ref$cache === void 0 ? true : _ref$cache;
  var uuid = Object(external_lodash_["uniqueId"])('api-request-');
  var payload = {
    ns: ns,
    endpoint: endpoint,
    method: method,
    params: params,
    uuid: uuid,
    cache: cache,
    userType: userType || defaultUserType
  };
  var key = getKey({
    ns: ns,
    endpoint: endpoint,
    method: method
  });

  if (!Object(external_lodash_["get"])(store.getState(), [reducerKey, key])) {
    store.dispatch(objectSpread_default()({
      type: API_INIT
    }, payload));
  }

  var request = clientDispatchWrapper(store.dispatch, payload);
  return {
    request: request,
    getState: function getState() {
      return Object(external_lodash_["get"])(store.getState(), "".concat(reducerKey, ".").concat(key));
    },
    cleanup: function cleanup() {
      return store.dispatch(objectSpread_default()({
        type: API_CLEANUP
      }, payload));
    }
  };
}

function ApiProvider(_ref2) {
  var store = _ref2.store,
      clients = _ref2.clients,
      children = _ref2.children,
      reducerKey = _ref2.reducerKey,
      defaultUserType = _ref2.defaultUserType;
  return external_react_default.a.createElement(ApiContext.Provider, {
    value: {
      clients: clients,
      defaultUserType: defaultUserType,
      getRequest: ApiProvider_getRequest.bind(null, store, reducerKey, defaultUserType)
    }
  }, children);
}

ApiProvider.propTypes = {
  store: external_prop_types_default.a.shape({
    getState: external_prop_types_default.a.func,
    dispatch: external_prop_types_default.a.func
  }).isRequired,
  clients: external_prop_types_default.a.object.isRequired,
  defaultUserType: external_prop_types_default.a.string,
  children: external_prop_types_default.a.node.isRequired,
  reducerKey: external_prop_types_default.a.string
};
ApiProvider.defaultProps = {
  reducerKey: 'api',
  defaultUserType: 'user'
};
/* harmony default export */ var components_ApiProvider = (ApiProvider);
// EXTERNAL MODULE: external "@babel/runtime/helpers/slicedToArray"
var slicedToArray_ = __webpack_require__(8);
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray_);

// CONCATENATED MODULE: ./src/hooks/useApi.js






function useApi(args) {
  var _useContext = Object(external_react_["useContext"])(ApiContext),
      getRequest = _useContext.getRequest;

  var _getRequest = getRequest(args),
      performRequest = _getRequest.request,
      getState = _getRequest.getState,
      cleanup = _getRequest.cleanup;

  var _useState = Object(external_react_["useState"])(null),
      _useState2 = slicedToArray_default()(_useState, 2),
      promise = _useState2[0],
      setPromise = _useState2[1];

  var _useState3 = Object(external_react_["useState"])(getState()),
      _useState4 = slicedToArray_default()(_useState3, 2),
      requestState = _useState4[0],
      setRequestState = _useState4[1];

  var request = function request(requestArgs) {
    var resp = performRequest(objectSpread_default()({}, args, requestArgs));
    setPromise(resp);
    setRequestState(getState());
    resp["finally"](function () {
      return setRequestState(getState());
    });
    return resp;
  };

  Object(external_react_["useEffect"])(function () {
    return cleanup;
  }, []);

  var requestOnMount = function requestOnMount() {
    return Object(external_react_["useEffect"])(function () {
      request(args);
    }, []);
  };

  return {
    request: request,
    promise: promise,
    requestOnMount: requestOnMount,
    requestState: requestState
  };
}
function load(endpoint, args) {
  var requestArgs = objectSpread_default()({
    method: 'get',
    endpoint: endpoint
  }, args);

  var _useApi = useApi(requestArgs),
      requestOnMount = _useApi.requestOnMount,
      requestState = _useApi.requestState,
      promise = _useApi.promise,
      request = _useApi.request;

  requestOnMount();
  return {
    reload: request,
    promise: promise,
    requestState: requestState
  };
}
var api = Object(external_lodash_["reduce"])(['get', 'post', 'patch', 'delete', 'put', 'head'], function (memo, method) {
  return objectSpread_default()({}, memo, defineProperty_default()({}, method, function (endpoint, args) {
    var _useApi2 = useApi(objectSpread_default()({
      method: method,
      endpoint: endpoint
    }, args)),
        request = _useApi2.request,
        requestState = _useApi2.requestState;

    return {
      request: request,
      requestState: requestState
    };
  }));
}, {});
// CONCATENATED MODULE: ./src/components/ApiResponse/index.js






function ApiResponse(_ref) {
  var endpoint = _ref.endpoint,
      _ref$render = _ref.render,
      Success = _ref$render.Success,
      Error = _ref$render.Error,
      Loading = _ref$render.Loading,
      children = _ref.children,
      requestArgs = objectWithoutProperties_default()(_ref, ["endpoint", "render", "children"]);

  var content;

  var _load = load(endpoint, requestArgs),
      reload = _load.reload,
      loadState = _load.requestState;

  var loaded = loadState.loaded,
      loading = loadState.loading,
      status = loadState.status;

  var renderProps = objectSpread_default()({
    reload: reload
  }, loadState);

  if (!loaded || loading) {
    content = external_react_default.a.createElement(Loading, renderProps);
  } else if (status >= 400 || status === 'timeout') {
    content = external_react_default.a.createElement(Error, renderProps);
  } else {
    content = external_react_default.a.createElement(Success, renderProps);
  }

  if (children) {
    return children(objectSpread_default()({
      content: content
    }, renderProps));
  }

  return content;
}

ApiResponse.propTypes = {
  endpoint: external_prop_types_default.a.string.isRequired,
  render: external_prop_types_default.a.shape({
    Success: external_prop_types_default.a.func.isRequired,
    Error: external_prop_types_default.a.func.isRequired,
    Loading: external_prop_types_default.a.func.isRequired
  }).isRequired,
  children: external_prop_types_default.a.func
};
/* harmony default export */ var components_ApiResponse = (ApiResponse);
// EXTERNAL MODULE: external "redux-saga/effects"
var effects_ = __webpack_require__(5);

// CONCATENATED MODULE: ./src/saga/index.js




var _marked =
/*#__PURE__*/
regenerator_default.a.mark(saga_request),
    _marked2 =
/*#__PURE__*/
regenerator_default.a.mark(apiRequest),
    _marked3 =
/*#__PURE__*/
regenerator_default.a.mark(watchApiRequest);




function onProgress(_ref) {
  var event = _ref.event,
      dispatch = _ref.dispatch,
      endpoint = _ref.endpoint,
      method = _ref.method,
      ns = _ref.ns;
  dispatch({
    type: API_PROGRESS,
    method: method,
    endpoint: endpoint,
    progress: event.percent,
    ns: ns
  });
}
function saga_request(_ref2) {
  var debounce, client, method, endpoint, data, params, dispatch, ns, response;
  return regenerator_default.a.wrap(function request$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          debounce = _ref2.debounce, client = _ref2.client, method = _ref2.method, endpoint = _ref2.endpoint, data = _ref2.data, params = _ref2.params, dispatch = _ref2.dispatch, ns = _ref2.ns;

          if (!debounce) {
            _context.next = 4;
            break;
          }

          _context.next = 4;
          return Object(effects_["delay"])(debounce);

        case 4:
          _context.next = 6;
          return Object(effects_["call"])([client, 'request'], {
            method: method,
            url: endpoint,
            params: params,
            data: data,
            onUploadProgress: function onUploadProgress(event) {
              return onProgress({
                event: event,
                dispatch: dispatch,
                endpoint: endpoint,
                method: method,
                ns: ns
              });
            }
          });

        case 6:
          response = _context.sent;
          return _context.abrupt("return", response);

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
function apiRequest(_ref3) {
  var client, resolve, reject, method, data, params, endpoint, dispatch, ns, debounce, cache, type, meta, payload, _ref4, _response, cancel, errors, status, _response2;

  return regenerator_default.a.wrap(function apiRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          client = _ref3.client, resolve = _ref3.resolve, reject = _ref3.reject, method = _ref3.method, data = _ref3.data, params = _ref3.params, endpoint = _ref3.endpoint, dispatch = _ref3.dispatch, ns = _ref3.ns, debounce = _ref3.debounce, cache = _ref3.cache, type = _ref3.type, meta = objectWithoutProperties_default()(_ref3, ["client", "resolve", "reject", "method", "data", "params", "endpoint", "dispatch", "ns", "debounce", "cache", "type"]);
          payload = objectSpread_default()({
            endpoint: endpoint,
            method: method,
            ns: ns,
            params: params
          }, meta);
          _context2.next = 4;
          return Object(effects_["put"])(objectSpread_default()({
            type: API_START,
            cache: cache,
            data: data
          }, payload));

        case 4:
          _context2.prev = 4;
          _context2.next = 7;
          return Object(effects_["race"])({
            response: Object(effects_["call"])(saga_request, objectSpread_default()({
              debounce: debounce,
              client: client,
              data: data,
              dispatch: dispatch
            }, payload)),
            cancel: Object(effects_["take"])(function (_ref5) {
              var nextType = _ref5.type,
                  nextEndpoint = _ref5.endpoint,
                  nextNs = _ref5.ns;
              return nextType === API && nextEndpoint === endpoint && nextNs === ns;
            })
          });

        case 7:
          _ref4 = _context2.sent;
          _response = _ref4.response;
          cancel = _ref4.cancel;

          if (!cancel) {
            _context2.next = 12;
            break;
          }

          return _context2.abrupt("return");

        case 12:
          if (!(method !== 'delete')) {
            _context2.next = 17;
            break;
          }

          _context2.next = 15;
          return Object(effects_["put"])(objectSpread_default()({
            type: API_SUCCESS,
            status: _response.status,
            data: _response.data,
            response: _response
          }, payload));

        case 15:
          _context2.next = 19;
          break;

        case 17:
          _context2.next = 19;
          return Object(effects_["put"])(objectSpread_default()({
            type: API_DESTROY,
            status: _response.status,
            data: _response.data,
            response: _response
          }, payload));

        case 19:
          if (!resolve) {
            _context2.next = 22;
            break;
          }

          _context2.next = 22;
          return Object(effects_["call"])(resolve, _response);

        case 22:
          _context2.next = 34;
          break;

        case 24:
          _context2.prev = 24;
          _context2.t0 = _context2["catch"](4);
          errors = Object(external_lodash_["get"])(_context2.t0, 'response.data.errors');
          status = Object(external_lodash_["get"])(_context2.t0, 'response.status', 'timeout');
          _response2 = Object(external_lodash_["get"])(_context2.t0, 'response');
          _context2.next = 31;
          return Object(effects_["put"])(objectSpread_default()({
            type: API_ERROR,
            status: status,
            errors: errors,
            response: _response2
          }, payload));

        case 31:
          if (!reject) {
            _context2.next = 34;
            break;
          }

          _context2.next = 34;
          return Object(effects_["call"])(reject, {
            status: status,
            response: _response2,
            errors: errors
          });

        case 34:
          _context2.next = 36;
          return Object(effects_["put"])(objectSpread_default()({
            type: API_COMPLETE
          }, payload));

        case 36:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[4, 24]]);
}
function watchApiRequest(clients) {
  return regenerator_default.a.wrap(function watchApiRequest$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Object(effects_["takeEvery"])(API, function () {
            var kwargs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var client = clients[kwargs.userType];
            return apiRequest(objectSpread_default()({
              client: client
            }, kwargs));
          });

        case 2:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
// CONCATENATED MODULE: ./index.js
/* concated harmony reexport ApiProvider */__webpack_require__.d(__webpack_exports__, "ApiProvider", function() { return components_ApiProvider; });
/* concated harmony reexport ApiContext */__webpack_require__.d(__webpack_exports__, "ApiContext", function() { return ApiContext; });
/* concated harmony reexport ApiResponse */__webpack_require__.d(__webpack_exports__, "ApiResponse", function() { return components_ApiResponse; });
/* concated harmony reexport useApi */__webpack_require__.d(__webpack_exports__, "useApi", function() { return useApi; });
/* concated harmony reexport api */__webpack_require__.d(__webpack_exports__, "api", function() { return api; });
/* concated harmony reexport load */__webpack_require__.d(__webpack_exports__, "load", function() { return load; });
/* concated harmony reexport apiReducer */__webpack_require__.d(__webpack_exports__, "apiReducer", function() { return src_reducer; });
/* concated harmony reexport API */__webpack_require__.d(__webpack_exports__, "API", function() { return API; });
/* concated harmony reexport API_INIT */__webpack_require__.d(__webpack_exports__, "API_INIT", function() { return API_INIT; });
/* concated harmony reexport API_START */__webpack_require__.d(__webpack_exports__, "API_START", function() { return API_START; });
/* concated harmony reexport API_PROGRESS */__webpack_require__.d(__webpack_exports__, "API_PROGRESS", function() { return API_PROGRESS; });
/* concated harmony reexport API_SUCCESS */__webpack_require__.d(__webpack_exports__, "API_SUCCESS", function() { return API_SUCCESS; });
/* concated harmony reexport API_DESTROY */__webpack_require__.d(__webpack_exports__, "API_DESTROY", function() { return API_DESTROY; });
/* concated harmony reexport API_ERROR */__webpack_require__.d(__webpack_exports__, "API_ERROR", function() { return API_ERROR; });
/* concated harmony reexport API_COMPLETE */__webpack_require__.d(__webpack_exports__, "API_COMPLETE", function() { return API_COMPLETE; });
/* concated harmony reexport apiSaga */__webpack_require__.d(__webpack_exports__, "apiSaga", function() { return watchApiRequest; });
/* concated harmony reexport getKey */__webpack_require__.d(__webpack_exports__, "getKey", function() { return getKey; });
/* concated harmony reexport asyncSaga */__webpack_require__.d(__webpack_exports__, "asyncSaga", function() { return asyncSaga; });















/***/ })
/******/ ]);
});